/* global ga, TweenMax */

export default class NewsletterModal {

  constructor() {

    $('.cta--newsletter').click( (e) => { this.handleNewsletterClick(e); });
    $('.overlay__close.newsletter').click( (e) => { this.closeNewsletter(e); } );
    $('#newsletter_overlayform').submit( (e) => { this.submitForm(e); } );

  }

  submitForm(e) {

    if ( !this.validateForm() ) {
      e.preventDefault();
    } else {
      setTimeout( () => {
        $('.form-response').text('Thank You!');
      }, 500 );
    }

  }


  validateForm() {
    let clean = true;

    if ( $('#mce-EMAIL2').val() === '' || $('#mce-EMAIL2').parent().hasClass('has-error') ) {
      clean = false;
      $('#mce-EMAIL2').parent().addClass('has-error');
    } else {
      $('#mce-EMAIL2').parent().removeClass('has-error');
    }

    return clean;
  }

  handleNewsletterClick(e) {
    e.preventDefault();

    if ($('section.newsletter').hasClass('is-active')) {
      this.closeNewsletter();
    } else {
      this.openNewsletter(e);
    }
  }

  openNewsletter() {
    console.log('OPEN NEWSLETTER');
    TweenMax.fromTo( $('section.newsletter .contact__form'), 1, { y: 20, opacity: 0 }, { opacity: 1, y: 0, delay: 0.25 } );

    $('section.newsletter').addClass('is-active');
    $('section.newsletter .modalAnchor').focus();

    $('section.newsletter .overlay__close').blur( () => {
      $('#mce-FNAME').focus();
    });

  }

  closeNewsletter() {
    $('section.newsletter').css('visibility', 'visible');
    $('section.newsletter').removeClass('is-active');
    TweenMax.to( $('section.newsletter .contact__form'), 0.5, { y: -10, opacity: 0 } );
    ga('send', 'event', 'Contact Modal', 'close', this.formid);

    console.log(this.formid);

    setTimeout( () => {
      this.resetForm();
    }, 500 );
  }

  resetForm() {
    $('section.newsletter input[type="text"]').val('');
    $('.form-formItem').removeClass('has-content has-error');
    $('.contact__form').scrollTop(0);
    $('.form-progress').removeClass('is-active');
    $('#contact-send').removeClass('is-deactivated is-hidden');
    $('.form-response').text('');
    $('.form-response').removeClass('is-active');
    $('section.newsletter').css('visibility', '');
  }

}



// WEBPACK FOOTER //
// ./js/modules/NewsletterModal.js